import { styled } from '../../base';

export const CustomStepIcon = styled('div')<{ isActive?: boolean }>(({ isActive, theme }) => ({
    zIndex: 2,
    color: isActive ? theme.palette.secondary.main : theme.palette.grey[600],
    backgroundColor: theme.palette.background.paper,
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: `2px solid ${isActive ? theme.palette.secondary.main : theme.palette.grey[400]}`,
    position: 'relative',
}));

export const StepConnector = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 45,
    left: '19px',
    height: 'calc(100% - 90px)',
    width: '2px',
    backgroundColor: theme.palette.grey[500],
    zIndex: 1,
}));